import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Analytics = Loadable(lazy(() => import('./ManageMarkupSection')));

const ManageMarkupRoutes = [
	{ path: '/dashboard/managemarkup', element: <Analytics />, auth: authRoles.admin },
];

export default ManageMarkupRoutes;
